import { Segment } from "semantic-ui-react";
import ComingSoonPlaceholder from '../../Assessment/ComingSoonPlaceholder'
import styles from "./DomainTasks.module.css"
import header from "../../Assessment/AssessmentInfoSlideControls/DomainTaskTitleComponent.module.css"
// import { DomainTaskTitle } from "./DomainTaskTitleComponent";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/medical/";


export const MedicalDomainTask1 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  
  return {
    header: "Geriatric Medical Assessment",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}MedicalModuleGeriatric.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                It is important for each older adult to develop a long-term relationship with a primary health care provider, that includes periodic geriatric assessments. Working with their primary care provider will help your adult attain and maintain the highest possible functional status. 
                </p>
                <p >
                In some areas geriatricians (specialists in care of older adults) are available to serve as primary care providers, but most older Americans rely on family physicians, internists, nurse practitioners, or physician assistants to provide primary care. The primary care provider takes the lead in monitoring the person’s health care team and is typically the one to whom patients turn first when a health problem arises.  
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>

      </>
    ),
  };
};

export const MedicalDomainTask2 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Monitoring Changes",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic style={{ display: "flex" }} >
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                A good relationship with the older adult’s primary care provider can be helpful as you attempt to understand your loved one's medical conditions and monitor changes that should be brought to the physician's attention. The people who spend the most time around the older adult will likely be the ones to notice these changes first.
                </p>
                <p >
                It is also important to determine the functional status of the older adult, which evaluates their capacity for independent living and will determine plans for care. Functional status can range from fully independent to needing assistance to fully dependent on others. By monitoring changes in the older adult's functional status, you can ensure they are receiving care based on their changing needs.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer} style={{ width: "100%" }}>{questionCompleter}</div>
            </div>
            <div style={{ float: "right" }}>
              <video style={{height: "calc(100% - 50px)"}} controls preload="auto" poster={`${cdnRoute}DadPlaceholder.jpg`} width="600" height="337">
                <source src={`${cdnRoute}dad-movie-clip-edited.mp4`} type="video/mp4"></source>
              </video>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask3 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Healthcare Team",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} >
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Becoming an active member of the older adult's healthcare team
                  can be very beneficial when it comes to maintaining their
                  health. Along with their physicians and other healthcare
                  professionals, you can play an active role in making the best
                  use of medical advice and treatment. If the older adult doesn't
                  have a good primary care physician, it is essential to help them
                  find one. The right healthcare team can make all the difference.
                </p>
                <p >
                  This process can work best when the older adult is also an
                  active member of the team. By educating themselves on health
                  condition and monitoring their health and symptoms, they can
                  share this information with their physicians and work together
                  to figure out best practices to reach their healthcare goals.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask4 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Medication Management",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic className={styles.imgGradientVertical} style={{ backgroundImage: `url(${cdnRoute}MedicalManagementSlide.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Older adults frequently take multiple medicines, some prescribed
                  by their physician and others purchased over the counter.
                  Keeping track of medication can become confusing for the older
                  adult and caregivers, especially when new ones are added, or
                  dosages are adjusted. Changes in functional status can also
                  increase the likelihood of medication-related issues.
                </p>
                <p >
                  One way to stay organized is to create a medication list. It is
                  helpful to include the name of each medication, what condition
                  the medication is used to treat, how much to take, when to take
                  it, and which doctor prescribed it. Give a copy to each of the
                  older adult's caregivers and be sure to keep it updated.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask5 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {

  return {
    header: "Evaluate Driving Skills",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} `}
            style={{ backgroundImage: `url(${cdnRoute}EvaluateDrivingSkills.png)` }}>
            <div className={`${styles.domainTaskContent} `}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                One of the most difficult issues older adults and family members face is whether the older adult can safely continue to drive an automobile. Often the older adult and family members have differing views of the older adult's driving skills. 
                </p>
                <p >
                This issue is best confronted long before any questions arise about the older adult's safety. By discussing the issue in advance of concerns, the older adult and family members can establish criteria (i.e., results of an objective driving skills evaluation or physician's recommendation) for limiting night driving or ceasing driving completely. Such plans should include concrete transportation alternatives, so that the older adult's independence and freedom of choice are not compromised.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask6 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Plan with Geriatric Care Manager",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={styles.imgGradientHorizontal}
            style={{ backgroundImage: `url(${cdnRoute}Medical_PlanWithGeriatricCareManager.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                Geriatric care managers are experts in planning and organizing a variety of services to meet the changing needs of older adults. Typically, they meet with older adults and family members to assess needs and discuss concerns that may arise (e.g., memory loss, functional impairment, difficult with transportation, household tasks).
                </p>
                <p >
                Following such an assessment, they create a plan of care. The plan includes recommendations about services to help the older adult remain at home safely or to move to a more appropriate living situation. Geriatric care managers provide a kind of “one-stop shop” to help older adults and their families access services and resources to promote successful aging. They work with families over time and reassess needs and services as circumstances change.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask7 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Assess Facility Quality",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`}
            style={{ backgroundImage: `url(${cdnRoute}Medical_AssessFacilityQuality.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                At some point in the future, it may be necessary for your older adult to live in a retirement community, assisted living residence, or other similar setting. It is important to become knowledgeable about the various choices in your older adult’s home community and how your older adult and others you trust (friends, clergy, health care professionals, family) view these residences.<br/>It may be desirable for the older adult to move to the community of the adult child.  
                </p>
                <p >
                Most such facilities are quite eager to take prospective residents and their family members for a tour, even years in advance of anticipated need, and will be happy to answer questions about services, costs, policies, and other matters. Knowing in advance of need which residences are most and least appropriate for your older adult will help aid in decision making, should they need such a facility for a short- or long-term stay.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask8 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Exercise and Activity Plan",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`}
            style={{ backgroundImage: `url(${cdnRoute}Medical_ExerciseAndActivityPlan.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                  Regular physical activity is one of the most important things the older adult can do for their health. It can help
                  to prevent or delay many common issues that come along with aging. Keeping their muscles strong can also help to
                  keep them independent for longer. Fitness and yoga classes can also be a great social opportunity as well.
                </p>
                <p >
                  Aerobic activities like walking, muscle-toning activities like using light weights, and balance activities like
                  standing on one leg or yoga can do wonders for older adults. Be sure to discuss this with their physician before
                  starting any type of exercise plan.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTask9 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Learn about Cognitive Impairment",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={styles.imgGradientHorizontal}
            style={{ backgroundImage: `url(${cdnRoute}Medical_LearnAboutCognitiveImpairment.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What Is This Task & Why Is It Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                Cognitive impairment is when a person has trouble remembering, learning new things, concentrating, or making decisions. The level of impairment can range from mild to severe and can change quickly. There are a variety of causes of cognitive impairment that can include side effects of medication, metabolic and/or endocrine dysfunction, vascular disease, and Alzheimer’s disease.
                </p>
                <p>
                Some causes (medication side effects, infections) can be treated successfully, and the impairment reversed.  Others (Alzheimer’s disease) are not reversible, but detection and treatment may slow the course of the disease.  
                </p>
                <p >
                It is important to keep track of any warning signs as cognitive impairment can drastically affect the care the older adult may need. Things like asking the same questions repeatedly, becoming lost in familiar places, losing things, getting confused often, and changes in mood and behavior can all be signs of cognitive impairment. If you notice any of these behaviors, consult the older adult's physician as soon as possible.
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};
export const MedicalDomainTask11 = (questionCompleter: any, topContentRef: React.RefObject<HTMLDivElement>) => {
  return {
    header: "Learn about Community Services",
    content: (
      <>
        <Segment basic className={styles.domainTaskSegment} >
          <Segment basic
            className={styles.imgGradientHorizontal}
            style={{ backgroundImage: `url(${cdnRoute}Medical_LearnAboutCommunityServices.png)`, }}>
            <div className={styles.domainTaskContent}>
              {/* <DomainTaskTitle /> */}
              <div className={header.domainTaskHeaderBlock} ref={topContentRef} >
                <p className={header.domainTaskHeader}>What is This Task and Why is it Important?</p>
              </div>
              <div className={styles.domainTaskCopy} >
                <p >
                In some communities, there is a wide variety of services available to help older adults attain and maintain optimal health.  In smaller towns and remote rural areas, it is harder to access such services.
                </p>
                <p>
                You and your older adult can familiarize yourselves with the resources available locally and those available via technology so that you can make sound choices about which may be most helpful in your specific situation. 
                </p>
              </div>
              <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
            </div>
          </Segment>
        </Segment>
      </>
    ),
  };
};

export const MedicalDomainTaskPlaceholder = () => {
  return {
    header: "Task Coming Soon",
    content: (
      <ComingSoonPlaceholder />
    ),
  };
};